import Handlebars from "handlebars";

class HandlebarsService {
  private templates: Map<string, HandlebarsTemplateDelegate> = new Map();

  async loadTemplate(name: string): Promise<HandlebarsTemplateDelegate> {
    if (this.templates.has(name)) {
      return this.templates.get(name)!;
    }

    const response = await fetch(`/templates/${name}.html`);
    if (!response.ok) {
      throw new Error(`Template introuvable : ${name}.html`);
    }
    const templateHtml = await response.text();
    if (!templateHtml.trim()) {
      throw new Error(`Template vide : ${name}.html`);
    }
    const compiled = Handlebars.compile(templateHtml);
    this.templates.set(name, compiled);
    return compiled;
  }

  async render(name: string, data: Record<string, any>): Promise<string> {
    const template = await this.loadTemplate(name);
    return template(data);
  }
}

export default new HandlebarsService();
